// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"15":"c8d2a914","48":"9b4e7b0f","197":"8f486e02","249":"6018431c","276":"bb6ced93","340":"b814fbcb","448":"62abd54e","473":"f323d670","602":"fd440a19","612":"4c6da1d1","618":"458b267d","810":"e956bb7f","965":"c194e685"}[chunkId] + ".js";
};